import { Component, Input } from '@angular/core';
import { LocalizeRouterService } from '@gilsdav/ngx-translate-router';
import { TranslateService } from '@ngx-translate/core';
import { ActivityInterface } from '@sport-activities/sdk';

import { getActivityDetailRouteName } from '~/attendee/helpers/activity/activity-detail-route-name.helper';
import { Parameters } from '~/cms/interfaces/dynamic-page.cms.interface';
import { Activity } from '~/core/model/activity.model';

@Component({
  selector: 'app-attendee-activity-collection',
  templateUrl: './activity-collection.component.html',
})
export class AttendeeActivityCollectionComponent {
  @Input() public activities: Activity[] = [];
  @Input() public description: string;
  @Input() public isLive: boolean;
  @Input() public moreLink: {
    parameters?: Parameters;
    path: string;
    text: string;
  };
  @Input() public parameters: Parameters;
  @Input() public seeMore?: boolean;
  @Input() public title: string;

  constructor(
    protected readonly translateService: TranslateService,
    protected readonly localizeRouterService: LocalizeRouterService
  ) {}

  public get link(): {
    parameters?: Parameters;
    path: string;
    text: string;
  } {
    if (this.moreLink) {
      return this.moreLink;
    }
    let ctaText = 'attendee.activity_collection.cta.see_more.label';
    let route = '/attendee.result-page/attendee.activities';
    if (this.isLive) {
      ctaText = 'attendee.activity_collection.cta.is_live.label';
      route = '/attendee.result-page/attendee.live-activities';
    }
    return {
      text: this.translateService.instant(ctaText),
      path: this.localizeRouterService.translateRoute(route).toString(),
      parameters: this.parameters,
    };
  }

  public getPath(activity: ActivityInterface): string {
    return getActivityDetailRouteName(activity.type, activity.sku);
  }
}
